import http, { backlog_downloader_with_progress, po_downloader_with_progress } from "../../http-common";

const po_data_post = (data) => {
  return http.post("v1/qc/open_po/", data);
};
const po_data_get = () => {
  return po_downloader_with_progress.get("v1/qc/open_po/");
};

const po_data_get_with_category = ({ category }) => {
  return po_downloader_with_progress.get(`v1/qc/open_po_new/${category}/?user=planner`);
};

const po_data_patch = (data) => {
  return http.patch('v1/qc/open_po/', data);
};

/**
 * #### Handler to get the backlog data w.r.t category
 * @param {String} category - Either INTM CB or FP
 * @returns backlog data for the mentioned category
 */
const backlog_data_get = (category) => {
  return backlog_downloader_with_progress.get(`v1/qc/backlog_po/${category}?role=planner`);
};

const sample_types_get = () => {
  return http.get("v1/qc/get_material_types");
};

export const PO_Backlog_Service = {
  po_data_post,
  po_data_get,
  po_data_get_with_category,
  po_data_patch,
  backlog_data_get,
  sample_types_get
};